import { render, staticRenderFns } from "./bo-select-with-search.vue?vue&type=template&id=04609c27"
import script from "./bo-select-with-search.vue?vue&type=script&lang=js"
export * from "./bo-select-with-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports